import { tokens } from '@fluentui/react-components';
import { themeVar } from './themeConfig';

const ENABLED_SELECTED_TAB = '& .fui-Tab[aria-selected="true"]:enabled';
const LABEL = '.fui-Tab__content';

const indicator = (fallback: string) => ({
  backgroundColor: themeVar('tabs', 'indicatorColor', fallback),
});

const label = (fallback: string) => ({
  color: themeVar('tabs', 'selectedColor', fallback),
});

export const themedTabListRules = {
  [`${ENABLED_SELECTED_TAB}::after`]: indicator(
    tokens.colorCompoundBrandStroke
  ),
  [`${ENABLED_SELECTED_TAB}:hover::after`]: indicator(
    tokens.colorCompoundBrandStrokeHover
  ),
  [`${ENABLED_SELECTED_TAB}:active::after`]: indicator(
    tokens.colorCompoundBrandStrokePressed
  ),
  [`${ENABLED_SELECTED_TAB} ${LABEL}`]: label(tokens.colorNeutralForeground1),
  [`${ENABLED_SELECTED_TAB}:hover ${LABEL}`]: label(
    tokens.colorNeutralForeground1Hover
  ),
  [`${ENABLED_SELECTED_TAB}:active ${LABEL}`]: label(
    tokens.colorNeutralForeground1Pressed
  ),
};
